import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import SearchOverlay from './SearchOverlay';
import { useLang } from '../hooks/useLang';
import './Header.css';

export default function Header() {
    const [lang] = useLang();
    const leadTamil = lang === 'ta';
    const [searchOpen, setSearchOpen] = useState(false);

    const openSearch = useCallback(() => setSearchOpen(true), []);
    const closeSearch = useCallback(() => setSearchOpen(false), []);

    // "/" keyboard shortcut, common convention for search focus. We ignore
    // it when the user is typing in a form field.
    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
            const target = e.target as HTMLElement | null;
            if (
                target &&
                (target.tagName === 'INPUT' ||
                    target.tagName === 'TEXTAREA' ||
                    target.isContentEditable)
            ) {
                return;
            }
            e.preventDefault();
            setSearchOpen(true);
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, []);

    return (
        <>
            <header className="app-header">
                <div className="app-header__inner">
                    <Link to="/" className="app-header__brand" aria-label="Meiporul — home">
                        {leadTamil ? (
                            <>
                                <span lang="ta" className="app-header__brand-ta">
                                    மெய்ப்பொருள்
                                </span>
                                <span className="app-header__brand-en">Meiporul</span>
                            </>
                        ) : (
                            <>
                                <span className="app-header__brand-en app-header__brand-en--lead">
                                    Meiporul
                                </span>
                                <span
                                    lang="ta"
                                    className="app-header__brand-ta app-header__brand-ta--secondary"
                                >
                                    மெய்ப்பொருள்
                                </span>
                            </>
                        )}
                    </Link>

                    <button
                        type="button"
                        className="app-header__search"
                        onClick={openSearch}
                        aria-label="Open search (press / anywhere)"
                    >
                        <span className="app-header__search-icon" aria-hidden="true">
                            ⌕
                        </span>
                        <span className="app-header__search-label">Search</span>
                        <kbd className="app-header__search-kbd" aria-hidden="true">
                            /
                        </kbd>
                    </button>

                    <nav className="app-header__nav" aria-label="Primary">
                        <Link to="/adhigarams">Adhigarams</Link>
                        <Link to="/divergence">Divergence</Link>
                        <Link to="/about">About</Link>
                    </nav>
                    <div className="app-header__right">
                        <ThemeToggle />
                        <LanguageToggle />
                    </div>
                </div>
            </header>
            <SearchOverlay open={searchOpen} onClose={closeSearch} />
        </>
    );
}
